import { useDispatch, useSelector } from "react-redux";
import { useState, useLayoutEffect, useRef, useEffect } from "react";
import CustomDialogBox from "../../components/global/CustomDialogBox.component";
import useWindowSize from "../../hooks/useWindowSize";
import CustomToolTip from "../../components/custom-tooltip/CustomTooltip.component";
import { addPad, replaceDynamicString } from "../../utils/helperFn";
import CustomButtonLoader from "../../components/global/CustomButtonLoader.component";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import OtpInputField from "../../components/auth/OtpInputField.component";
import { openSnackBar } from "../../redux/actions/snackbar.actions";

const staticDataForMfa = {
  type: "FIRST_STEP",
  otp: Array(6).fill(""),
  otpHasErrorMsg: "",
};
const resendOtpTime = 60; // TIME IN SECOND
const MfaFormDialogContainer = ({ t, dialogMfaData, handleResetDialogMfaData, actionHandler, handleDialogMfaDataChange }) => {
    const windowSize = useWindowSize();
    const dispatch = useDispatch();
    const envState = useSelector((state) => state.env);
    const [enableTimeFlag, setEnableTimeFlag] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(resendOtpTime);

    const endTimeRef = useRef(null);

    useEffect(() => {
        if(!dialogMfaData?.dialogStatus && enableTimeFlag) {
            setEnableTimeFlag(false);
            setSecondsLeft(resendOtpTime);
        }
    }, [dialogMfaData?.dialogStatus]);

    useLayoutEffect(() => {
        if (!enableTimeFlag && dialogMfaData?.type === "SECOND_STEP_EMAIL") {
        endTimeRef.current = new Date().getTime() + resendOtpTime * 1000 - 100;
        const interval = setInterval(() => {
            const now = new Date().getTime();
            const timeRemaining = Math.max(
            0,
            Math.round((endTimeRef.current - now) / 1000)
            );
            if (timeRemaining <= 0) {
            setSecondsLeft(resendOtpTime);
            setEnableTimeFlag(true);
            clearInterval(interval);
            } else {
            setSecondsLeft(timeRemaining);
            }
        }, 1000);
        return () => clearInterval(interval);
        } else {
            setSecondsLeft(resendOtpTime);
        }
    }, [enableTimeFlag, dialogMfaData?.type]);

    const handleFormSubmit = (e) => {
        e.preventDefault();
        // if (!textBoxStr.value) {
        // textBoxStrHandler({
        //     ...textBoxStr,
        //     msg: "empty_passcode_please_try_again",
        // });
        // return;
        // }
        // onSaveHandler(textBoxStr.value);
    };

    const renderAuthenticators = () => {
        if(envState?.AUTHENTICATORS) {
            const struct = [" "];
            envState.AUTHENTICATORS.forEach((authenticator, index, arr) => {
                if(index === (arr.length - 1)) {
                    struct.push(" " + t("or") + " ");
                }

                struct.push(
                    authenticator.enabled ? <a
                        className="text-action-1 cm-pointer"
                        href={authenticator.link}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t(authenticator.value)}
                    </a> : <CustomToolTip
                        title={replaceDynamicString(t("authenticator_method_unavailable_in_your_region"), [t(authenticator.value)])}
                        disableTooltip={authenticator.enabled}
                    >
                        <span className="cm-action-disabled cm-default">{t(authenticator.value)}</span>
                    </CustomToolTip>
                ) 

                if(index < (arr.length - 2)) {
                    struct.push(", ");
                }
            });

            struct.push(" ")

            return struct;
        }

        return null;
    }

    const actionHandlerWrapper = (e) => {
        e.preventDefault();
        actionHandler();
    };

    const csshander = (val) => {
      if (
        (val === "via_authenticator_app" && dialogMfaData.viaAuthenticator) ||
        (val === "via_email_id" && dialogMfaData.viaEmail)
      ) {
        return "border-action-blue text-blue-800 cm-bg-blue-light";
      } else if (
        dialogMfaData.originalAuthenticationType !== "EMAIL_AND_AUTHENTICATION_APP"
      ) {
        return "border-blue-300 text-blue-gray-400";
      } else {
        return "border-blue-300 text-blue-800 cm-pointer";
      }
    };

    const renderView = () => {
        if (dialogMfaData?.type === "SECOND_STEP_EMAIL") {
            return (
                <form onSubmit={actionHandlerWrapper}>
                    <div className="px-32">
                        <p
                        className={`fw-medium cm-sm-txt mb-4 text-break ${
                            windowSize.isMobile ? "text-white" : "text-blue-gray-700"
                        }`}
                        >
                        {t("enter_verification_code_sent_email_id") + ` "`}
                        <span
                            className={`${
                            windowSize.isMobile ? "text-white" : "text-blue-800"
                            }`}
                        >
                            {dialogMfaData.emailId}
                        </span>
                        "
                        </p>
                        <p
                        className={`mb-12 cm-xs-txt  fw-medium ${
                            windowSize.isMobile ? "text-white" : "text-blue-gray-700"
                        }`}
                        >
                        {t("enter_digit_verification_code_generated")}
                        </p>
                        <OtpInputField
                            t={t}
                            otp={dialogMfaData.otp}
                            hasErrorMsg={dialogMfaData.otpHasErrorMsg}
                            mfadataHandler={handleDialogMfaDataChange}
                        />
                        <div className="mb-0 mt-3 d-flex">
                            <CustomToolTip
                                title={t("resend_button_enabled_in_some_time_toolip")}
                                disableTooltip={enableTimeFlag}
                            >
                                <p
                                    className={`fw-medium cm-sm-txt my-auto ${
                                        enableTimeFlag
                                        ? "text-decoration-underline text-blue-500 cm-pointer"
                                        : "text-blue-gray-500"
                                    }`}
                                    onClick={() => {
                                        if (!enableTimeFlag) return;
                                        setEnableTimeFlag(false);
                                        actionHandler("RESEND_OTP");
                                    }}
                                >{t("resend_otp")}</p>
                            </CustomToolTip>
                            {!!secondsLeft && !enableTimeFlag && (
                                <p className="my-auto fw-medium cm-sm-txt text-blue-500 ms-3 ps-3 border-start border-blue-gray-300">
                                <span className="text-blue-gray-700">{t("time_remaining")}</span>
                                {" 00:" + addPad(Math.ceil(secondsLeft)) + "s"}
                                </p>
                            )}
                        </div>
                    </div>
                    <hr className="cm-auth-hr bg-blue-gray-300 mt-4 mb-3 w-100" />
                    <div className="d-flex px-32 justify-content-end">
                        <CustomButtonLoader
                            showLoadingState={false}
                            disabled={dialogMfaData.originalAuthenticationType !== "EMAIL_AND_AUTHENTICATION_APP"}
                            icon={""}
                            buttonLabel={t("verify_via_another_method")}
                            colorTheme={"white"}
                            textColor={"text-action-blue"}
                            buttonStyle={"me-12 py-2 px-3 fw-medium"}
                            handleOnClick={() => {
                                handleDialogMfaDataChange({
                                    ...staticDataForMfa,
                                });
                            }}
                        />
                        <CustomButtonLoader
                            showLoadingState={false}
                            disabled={false}
                            icon={regular("angle-right")}
                            buttonLabel={t("submit")}
                            colorTheme={"hoverBlue2"}
                            buttonStyle={"py-2 px-3 cm-mar-left-icon fw-medium"}
                            handleOnClick={() => {}}
                        />
                    </div>
                </form>
            );
        }

        if (dialogMfaData?.type === "SECOND_STEP_APP") {
            return (
            <form onSubmit={actionHandlerWrapper}>
                <div className="px-32">
                    <p
                    className={`my-0 fw-medium cm-sm-txt ${
                        windowSize.isMobile ? "text-white" : "text-blue-gray-700"
                    }`}
                    >
                    {t("please_enter_the_verification_code_authenticator")}
                    </p>
                    <p
                    className={`my-0 fw-medium cm-sm-txt mb-12 mt-4 ${
                        windowSize.isMobile ? "text-white" : "text-blue-gray-700"
                    }`}
                    >
                    {t("enter_digit_verification_code_generated")}
                    </p>
                    <OtpInputField
                        t={t}
                        otp={dialogMfaData.otp}
                        hasErrorMsg={dialogMfaData.otpHasErrorMsg}
                        mfadataHandler={handleDialogMfaDataChange}
                    />
                </div>
                <hr className="cm-auth-hr bg-blue-gray-300 mt-4 mb-3 w-100" />
                <div className="d-flex px-32 justify-content-end">
                    <CustomButtonLoader
                        showLoadingState={false}
                        disabled={dialogMfaData.originalAuthenticationType !== "EMAIL_AND_AUTHENTICATION_APP"}
                        icon={""}
                        buttonLabel={t("verify_via_another_method")}
                        colorTheme={"white"}
                        buttonStyle={"me-12 py-2 px-3 fw-medium"}
                        textColor={"text-action-blue"}
                        handleOnClick={() => {
                            handleDialogMfaDataChange({
                                ...staticDataForMfa,
                            });
                        }}
                    />
                    <CustomButtonLoader
                        showLoadingState={false}
                        disabled={false}
                        icon={regular("angle-right")}
                        buttonLabel={t("submit")}
                        colorTheme={"hoverBlue2"}
                        buttonStyle={"py-2 px-3 cm-mar-left-icon fw-medium"}
                        handleOnClick={() => {}}
                    />
                </div>
            </form>
            );
        }


        if(dialogMfaData?.type === "FIRST_STEP") {
            return <>
                <div className="px-32">
                    <CustomToolTip
                        title={t("this_method_is_currently_disabled_account")}
                        disableTooltip={
                            dialogMfaData.originalAuthenticationType !== "AUTHENTICATION_APP"
                        }
                    >
                        <div
                            className={`d-flex px-3 py-12 border fw-medium cm-btn-radius mb-3 ${csshander(
                            "via_email_id"
                            )}`}
                            onClick={() => {
                                if (dialogMfaData.originalAuthenticationType === "AUTHENTICATION_APP")
                                    return;
                                handleDialogMfaDataChange({ viaEmail: true, viaAuthenticator: false });
                            }}
                        >
                            <input
                            type="radio"
                            id="via_email_id"
                            value={dialogMfaData.viaEmail}
                            checked={dialogMfaData.viaEmail}
                            disabled={
                                dialogMfaData.originalAuthenticationType === "AUTHENTICATION_APP"
                            }
                            className={`${
                                dialogMfaData.viaEmail
                                ? ""
                                : dialogMfaData.originalAuthenticationType === "AUTHENTICATION_APP"
                                ? ""
                                : "cm-pointer"
                            }`}
                            />
                            <label
                            for="via_email_id"
                            className={`cm-sm-txt text-center flex-grow-1 ${
                                windowSize.isMobile ? "text-white" : ""
                            } ${
                                dialogMfaData.viaEmail
                                ? ""
                                : dialogMfaData.originalAuthenticationType === "AUTHENTICATION_APP"
                                ? ""
                                : "cm-pointer"
                            }`}
                            >
                            {t("via_email_id")}
                            </label>
                        </div>
                    </CustomToolTip>
                    <CustomToolTip
                    title={t("this_method_is_currently_disabled_account")}
                    disableTooltip={dialogMfaData.originalAuthenticationType !== "EMAIL"}
                    >
                        <div
                            className={`d-flex cm-sm-txt px-3 py-12 border fw-medium cm-btn-radius ${csshander(
                            "via_authenticator_app"
                            )} `}
                            onClick={() => {
                            if (dialogMfaData.originalAuthenticationType === "EMAIL") return;
                            handleDialogMfaDataChange({ viaEmail: false, viaAuthenticator: true });
                            }}
                        >
                            <input
                            type="radio"
                            id="via_authenticator_app"
                            value={dialogMfaData.viaAuthenticator}
                            checked={dialogMfaData.viaAuthenticator}
                            disabled={dialogMfaData.originalAuthenticationType === "EMAIL"}
                            className={`${
                                dialogMfaData.viaAuthenticator
                                ? ""
                                : dialogMfaData.originalAuthenticationType === "EMAIL"
                                ? ""
                                : "cm-pointer"
                            }`}
                            />
                            <label
                            for="via_authenticator_app"
                            className={`text-center flex-grow-1 ${
                                windowSize.isMobile ? "text-white" : ""
                            } ${
                                dialogMfaData.viaAuthenticator
                                ? ""
                                : dialogMfaData.originalAuthenticationType === "EMAIL"
                                ? ""
                                : "cm-pointer"
                            }`}
                            >
                            {t("via_authenticator_app")}
                            </label>
                        </div>
                    </CustomToolTip>
                    {(dialogMfaData.viaEmail || dialogMfaData.viaAuthenticator) && (
                    <p
                        className={`mt-3 mb-0 fw-medium cm-sm-txt ${
                        windowSize.isMobile ? "text-white" : "text-blue-gray-700"
                        }`}
                    >
                        {dialogMfaData.viaEmail ? (
                        t("you_will_receive_digit_verification_code")
                        ) : (
                        <>
                            <p className="cm-sm-txt text-blue-gray-700 mb-0">

                            {t("download_install_any_authenticator_apps_like_auth")}
                            {renderAuthenticators()}
                            {t("to_generate_login_codes")}
                            </p>
                        </>
                        )}
                    </p>
                    )}
                </div>
                <hr className="cm-auth-hr bg-blue-gray-300 mt-4 mb-3 w-100" />
                <div className="d-flex px-32 justify-content-end">
                    <CustomButtonLoader
                        showLoadingState={false}
                        disabled={false}
                        icon={regular("angle-right")}
                        buttonLabel={t(`${t("next")}`)}
                        colorTheme={"hoverBlue2"}
                        buttonStyle={"py-2 px-32 cm-mar-left-icon fw-medium"}
                        handleOnClick={() => {
                        if (dialogMfaData.viaAuthenticator || dialogMfaData.viaEmail) {
                            actionHandler();
                        } else {
                            dispatch(
                                openSnackBar({
                                    msg: t("select_one_of_the_above_selection"),
                                    type: "info",
                                })
                            );
                        }
                        }}
                    />
                    {/* {!!dialogMfaData.isBackButtonStr && (
                        <CustomButtonLoader
                        showLoadingState={false}
                        disabled={false}
                        icon={null}
                        buttonLabel={t(`${t("back")}`)}
                        colorTheme={"white"}
                        buttonStyle={"mt-32 py-2 px-32 ms-12 fw-medium"}
                        handleOnClick={() => {
                            mfadataHandler({
                            type: mfadata.isBackButtonStr,
                            isBackButtonStr: "",
                            backButtonHistory: {
                                type: "",
                                defaultAuthenticationTypeFlag: "",
                            },
                            });
                        }}
                        />
                    )} */}
                </div>
            </>
        }
    }

    return (
        <CustomDialogBox
            t={t}
            dialogHeading={dialogMfaData?.dialogHeading ? t(dialogMfaData?.dialogHeading) : ''}
            cancelFn={handleResetDialogMfaData}
            dialogStatus={dialogMfaData?.dialogStatus}
            disabled={false}
            buttonArrayData={[]}
            disablePadding={true}
            dialogWidth="500px"
        >
            <div className="pt-4 pb-3">
                {renderView()}
            </div>
        </CustomDialogBox>
    )
}

export default MfaFormDialogContainer;